// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 23C10.4971 22.9999 9.02898 22.5483 7.78588 21.7037C6.54278 20.8592 5.58207 19.6606 5.02832 18.2635C4.47456 16.8664 4.3533 15.3352 4.68025 13.8683C5.00721 12.4015 5.7673 11.0667 6.86197 10.037C8.20397 8.774 11.5 6.5 11 1.5C17 5.5 20 9.5 14 15.5C15 15.5 16.5 15.5 19 13.03C19.27 13.803 19.5 14.634 19.5 15.5C19.5 17.4891 18.7098 19.3968 17.3033 20.8033C15.8968 22.2098 13.9891 23 12 23Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
